// @needs-native-review — best-effort translation
import type { ChromeTranslations } from '../types';

export const vi: ChromeTranslations = {
  'nav.nextPage': 'trang tiếp →',
  'nav.previousPage': '← trang trước',
  'nav.continueToLevel': 'tiếp tục đến màn →',
  'nav.backToMenu': 'về menu →',
  'howto.page': 'trang {n} trong {total}',
  'options.title': 'Tùy chọn',
  'ui.language': 'Ngôn ngữ',
};
